export interface AuthXUserIdentityToken {
  token: string
  tenantCode: string
}

export enum Partner {
  SiteMinder = 'siteminder',
  LittleHotelier = 'littlehotelier',
}

export enum PartnerDisplayName {
  SiteMinder = 'SiteMinder',
  LittleHotelier = 'Little Hotelier',
}
